window.ZoneMap = {
	myMap: null,
	myPlacemark: null,
	singleMode: false,
	ymlLoaded: false,
	satelliteButtons: [],
	satelliteIcons: [],
	satelliteLines: [],

	zoneMapElement: null,

	isMobile: function () {
		return $(window).width() <= 600;
	},

	zoneMap: function () {
		if (!this.zoneMapElement)
			this.zoneMapElement = $("#zone-map");

		return this.zoneMapElement;
	},

	zoneMapData: function () {
		return this.zoneMap().data('data');
	},

	getSatelliteConfig(id) {
		let data = this.zoneMapData();
		for (let i in data) {
			let item = data[i];
			if (item.id == id) return item;
		}
	},

	initMap: function () {
		ZoneMap.myMap = new ymaps.Map('zone-map', {
			center: [50.994675, 70.702651], // Москва
			zoom: ZoneMap.isMobile() ? 1 : 2,
			controls: ['zoomControl', 'rulerControl', 'typeSelector'],
		});

		//ZoneMap.myMap.behaviors.disable('scrollZoom');

		ZoneMap.initPlacemark();
		ZoneMap.loadYml();
		ZoneMap.initMapSuggestView();
		ZoneMap.initButtons();
		ZoneMap.initSatelliteIcons();
		ZoneMap.initSatelliteIconsLines();
		ZoneMap.initCachedAddress();
		ZoneMap.initCurrentLocation();

		$(window).trigger('resize');
	},

	initPlacemark: function () {
		ZoneMap.myPlacemark = new ymaps.Placemark([45.035515, 38.969269], {}, {
			draggable: true
		});

		ZoneMap.myMap.geoObjects.add(ZoneMap.myPlacemark);

		ZoneMap.myPlacemark.events.add("drag", function (e) {
			//ZoneMap.singleMode = false;
			ZoneMap.highlight();
			ZoneMap.setCoords(e.get('target').geometry.getCoordinates());
			ZoneMap.calcData();
		}, ZoneMap.myPlacemark);

		ZoneMap.myPlacemark.events.add("dragend", function (e) {
			ZoneMap.highlight();
			ZoneMap.setAddressFromCoords(e.get('target').geometry.getCoordinates());
		}, ZoneMap.myPlacemark);
	},

	initMapSuggestView: function () {
		var suggestView = new ymaps.SuggestView("sputnik_place");
		suggestView.events.add('select', function (e) {
			var addr = $.trim(e.get('item').value);

			let setCoords = function (coords) {
				localStorage.setItem('coverage-address', addr);
				localStorage.setItem('coverage-coords', coords);

				ZoneMap.setCoords(coords);
				ZoneMap.setCoordsCenter(coords);
				ZoneMap.movePlacemark(coords);
				ZoneMap.highlight();
				ZoneMap.calcData();
			};

			let coordsSegment = addr.split(',');
			if (coordsSegment.length == 2 && !isNaN(coordsSegment[0]) && !isNaN(coordsSegment[1])) {
				let coords = [
					coordsSegment[0],
					coordsSegment[1]
				];
				setCoords(coords);
			} else {
				ymaps.geocode(addr, {
					results: 1
				}).then(function (res) {
					let firstGeoObject = res.geoObjects.get(0);
					let coords = firstGeoObject.geometry.getCoordinates();
					setCoords(coords);
				});
			}
		});
	},

	initButtons: function () {
		var satellites = ZoneMap.zoneMapData();

		satellites.forEach(function (item, i) {
			let btn = new ymaps.control.Button({
				data: {
					content: item.title,
					id: item.id,
				},
				options: {
					maxWidth: [170, 190, 220],
				},
			});

			btn.events.add('click', function (e) {
				let data = e.get('target').data;
				let id = data.get('id');
				let selected = e.get('target').state.get('selected');

				e.get('target').state.set('selected', !e.get('target').state.get('selected'));

				let checkedButtons = ZoneMap.getSelectedSatelliteButtons();

				if (checkedButtons.length) {
					ZoneMap.hideAllObjects();

					ZoneMap.satelliteButtons.forEach(function (item) {
						let id = item.data.get('id');
						let $sputnik = $(".vg-area-coverage .sputnik[data-id='" + id + "']");
						let checked = item.state.get('selected');

						if (checked) {
							$sputnik.removeClass('hide');
							ZoneMap.showSatelliteObjects(id);
						} else {
							$sputnik.addClass('hide');
						}
					});

					ZoneMap.singleMode = true;
				} else {
					$(".vg-area-coverage .sputnik[data-id]").removeClass('hide');
					ZoneMap.showAllObjects();

					ZoneMap.singleMode = false;
				}

				ZoneMap.highlight();

				e.get('target').state.set('selected', !e.get('target').state.get('selected'));
			});

			ZoneMap.satelliteButtons.push(btn);
			let btnParams = ZoneMap.isMobile() ? {
				float: 'left',
				floatIndex: 100 - i
			} : {
				position: {
					top: 20 + (i + 1) * 35,
					right: 10
				}
			};
			ZoneMap.myMap.controls.add(btn, btnParams);
		});

		ZoneMap.satelliteButtons[0].state.set('selected', true);
	},

	disabledSatelliteButtons: function () {
		ZoneMap.satelliteButtons.forEach(function (item) {
			item.state.set('selected', false);
		});
	},

	enableSatelliteButtons: function () {
		ZoneMap.satelliteButtons.forEach(function (item) {
			item.state.set('selected', true);
		});
	},

	enableSatelliteButton: function (id) {
		ZoneMap.satelliteButtons.forEach(function (item) {
			if (id == item.data.get('id')) {
				item.state.set('selected', true);
			}
		});
	},

	getSelectedSatelliteButtons: function () {
		return ZoneMap.satelliteButtons.filter(function (item) {
			return item.state.get('selected');
		});
	},

	initSatelliteIcons: function () {
		let satellites = ZoneMap.zoneMapData();

		satellites.forEach(function (item, i) {
			let l = new ymaps.Placemark([0, item.standing_coords], {
				hintContent: item.title,
			}, {
				iconLayout: "default#image",
				iconImageHref: "/assets/_frontend/images/icons/satellite.svg",
				iconImageSize: [32, 32],
				iconImageOffset: [-17, -16],
				data: {
					item: item,
				},
				visible: false,
			});

			ZoneMap.satelliteIcons.push(l);
			ZoneMap.myMap.geoObjects.add(l);
		});
	},

	initSatelliteIconsLines: function () {
		let placemarkCoords = ZoneMap.getPlacemarkCoordinates();

		ZoneMap.satelliteIcons.forEach(function (icon) {
			let item = icon.options.get('data').item;

			let g = new ymaps.GeoObject({
				geometry: {
					type: "LineString",
					coordinates: [
						placemarkCoords,
						[0, item.standing_coords]
					]
				}
			}, {
				visible: false,
				id: item.id,
				geodesic: true,
				strokeColor: "#3d9ad8",
				strokeWidth: 3,
			});

			ZoneMap.myMap.geoObjects.add(g);
			ZoneMap.satelliteLines.push(g);
		});
	},

	enableSatelliteIcons: function (ids) {
		if (typeof ids === 'object') {
			for (var i in ids) {
				ZoneMap.enableSatelliteIcons(ids[i]);
			}

			return true;
		}

		ZoneMap.satelliteIcons.forEach(function (item) {
			let itemId = item.options.get('data').item.id;
			if (ids == itemId) {
				item.options.set('visible', true);
				return true;
			}
		});
	},

	toggleSatelliteIcons: function (ids) {
		ZoneMap.satelliteIcons.forEach(function (item) {
			let itemId = item.options.get('data').item.id;
			let active = ids.indexOf(itemId) !== -1;
			item.options.set('visible', active);
		});
	},

	toggleSatelliteLines: function (ids) {
		ZoneMap.satelliteLines.forEach(function (line) {
			let itemId = line.options.get('id');
			let active = ids.indexOf(itemId) !== -1;

			if (active) {
				let coords = ZoneMap.getPlacemarkCoordinates();
				line.geometry.set(0, coords);
			}

			line.options.set('visible', active);
		});
	},

	disabledSatelliteIcons: function () {
		ZoneMap.satelliteIcons.forEach(function (item) {
			item.options.set('visible', false);
		});
	},

	showSatelliteObjects: function (id) {
		ymaps.geoQuery(this.myMap.geoObjects)
			.search('options._sid = ' + id)
			.setOptions({
				visible: true,
			});
	},

	showPlacemark: function () {
		ZoneMap.myPlacemark.options.set('visible', true);
	},

	hideAllObjects: function () {
		ymaps.geoQuery(ZoneMap.myMap.geoObjects).search('options.zone=1').setOptions({
			visible: false
		});
	},

	showAllObjects: function () {
		ymaps.geoQuery(ZoneMap.myMap.geoObjects).search('options.zone=1').setOptions({
			visible: true
		});
	},

	toggleSatellites: function (satellitesIds) {
		let $sputniks = $(".vg-area-coverage .sputnik");
		$sputniks.addClass('hide');

		ZoneMap.toggleSatelliteButtons(satellitesIds);
		ZoneMap.toggleSatelliteIcons(satellitesIds);
		ZoneMap.toggleSatelliteLines(satellitesIds);
		ZoneMap.toggleSatelliteSputniks(satellitesIds);
	},

	toggleSatelliteButtons: function (ids) {
		ZoneMap.satelliteButtons.forEach(function (item) {
			let itemId = item.data.get('id');
			let active = ids.indexOf(itemId) !== -1;
			item.state.set('selected', active);
		});
	},

	toggleSatelliteSputniks: function (ids) {
		let $sputniks = $(".vg-area-coverage .sputnik");

		$sputniks.each(function (i, e) {
			let active = ids.indexOf($(e).data('id')) !== -1;
			if (active) {
				$(e).removeClass('hide');
			} else {
				$(e).addClass('hide');
			}
		});
	},

	enableSatellite: function (id) {
		$(".vg-area-coverage .sputnik[data-id='" + id + "']").removeClass('hide');
		ZoneMap.enableSatelliteButton(id);
		ZoneMap.enableSatelliteIcons(id);
	},

	highlight: function () {
		let objects = ymaps.geoQuery(ZoneMap.myMap.geoObjects).search('options.zone=1');

		if (ZoneMap.singleMode) {
			let ids = ZoneMap.getSelectedSatelliteButtons().map(function (item) {
				return item.data.get('id')
			});

			ids.forEach(function (id) {
				// объекты выбранных спутников
				let sidObjects = objects.search('options._sid = ' + id);
				sidObjects.setOptions({
					visible: true
				}).each(function (e) {
					e.options.set({
						strokeOpacity: .1,
					});
				});

				// объекты выбранных спутников которые входят в плейсмарк
				let objectsInPlacemark = sidObjects.searchContaining(ZoneMap.myPlacemark);
				objectsInPlacemark.setOptions({
					visible: true,
				}).each(function (e) {
					e.options.set({
						strokeOpacity: .5,
					});
				});
			});

			ZoneMap.toggleSatelliteIcons(ids);
			ZoneMap.toggleSatelliteLines(ids);
		} else {
			let objectsInPlacemark = objects.searchContaining(ZoneMap.myPlacemark);

			// показываем нужные нам объекты
			objectsInPlacemark.setOptions({
				visible: true
			});

			// скрываем все остальные
			objects.remove(objectsInPlacemark).setOptions({
				visible: false
			});

			let satelliteIds = uniqueArray(function () {
				let satellitesIds = [];
				objectsInPlacemark.each(function (item) {
					satellitesIds.push(item.options.get('_sid'));
				});
				return satellitesIds;
			}());

			this.toggleSatellites(satelliteIds);
		}
	},

	loadYml: function () {
		let satellites = this.zoneMapData();

		let cntYml = satellites.length;
		let cntLoadedYml = 0;

		satellites.forEach(function (item) {
			var url = item.file;
			var id = item.id;

			ymaps.geoXml.load(url)
				.then(function (res) {
					res.geoObjects.each(function (e) {
						e.options.set({
							strokeOpacity: .5,
							strokeWidth: .1,
						});
					});

					let options = {
						_sid: id,
						zone: 1,
						visible: false,
						preset: "gpx#plain"
					};

					if (parseInt(item.fill_map)) {
						options.fillOpacity = .1;
					} else {
						options.fillOpacity = 0;
					}

					res.geoObjects.options.set(options);

					res.geoObjects.events.add('balloonopen', function (e) {
						var b = e.get('target');
						let resultText = b.properties.get('balloonContent');

						let textStartPos = resultText.indexOf('text:');
						if (textStartPos !== -1) {
							resultText = strip_tags(resultText.substring(textStartPos + 5));
							resultText = "<div class='text-text'>" + resultText + "</div>";
						}

						if (resultText.indexOf('text-text') !== -1) {
							b.properties.set('balloonContent', resultText)
						} else {
							b.balloon.close();
						}
					});

					ZoneMap.myMap.geoObjects.add(res.geoObjects);

					if (ZoneMap.satelliteChecked(id)) {
						ZoneMap.showSatelliteObjects(id);
						ZoneMap.enableSatellite(id);
					}

					cntLoadedYml++;

					if (cntLoadedYml >= cntYml) {
						ZoneMap.ymlLoaded = true;
					}
				});
		});
	},

	getPlacemarkCoordinates: function () {
		return this.myPlacemark.geometry.getCoordinates();
	},

	movePlacemark: function (coords) {
		this.myPlacemark.geometry.setCoordinates(coords);
	},

	satelliteChecked: function (id) {
		ZoneMap.satelliteButtons.forEach(function (item) {
			if (id == item.data.get('id')) {
				return item.state.get('selected');
			}
		});
	},

	setCoords: function (coords) {
		if (!coords) {
			$("#sputnik_lat, #sputnik_lon").val('');
		} else {
			$("#sputnik_lat").val(parseFloat(coords[0]).toFixed(4));
			$("#sputnik_lon").val(parseFloat(coords[1]).toFixed(4));
		}
	},
	setCoordsCenter: function (coords) {
		this.myMap.setCenter(coords, 13);
	},
	setAddressFromCoords: function (coords) {
		ymaps.geocode(coords).then(function (res) {
			var a = res.geoObjects.get(0).properties.getAll();

			$("#sputnik_place").val(a.text);
		});
	},

	setAddress: function (addr) {
		$("#sputnik_place").val(addr);
	},

	initCachedAddress: function () {
		let addr = localStorage.getItem('coverage-address');
		if (addr) this.setAddress(addr);

		let coords = localStorage.getItem('coverage-coords');
		if (coords) {
			coords = coords.split(',');
			ZoneMap.setCoords(coords);
			ZoneMap.setCoordsCenter(coords);

			ZoneMap.runAfterYmlLoaded(function () {
				ZoneMap.movePlacemark(coords);
				ZoneMap.highlight();
				ZoneMap.calcData();
			});
		}
	},

	initCurrentLocation: function () {
		let coords = localStorage.getItem('coverage-coords');
		if (coords) return false;

		ymaps.geolocation.get().then(
			function (result) {
				let coords = result.geoObjects.get(0).geometry.getCoordinates();

				ZoneMap.setAddressFromCoords(coords);
				ZoneMap.setCoords(coords);
				ZoneMap.setCoordsCenter(coords);

				ZoneMap.runAfterYmlLoaded(function () {
					ZoneMap.movePlacemark(coords);
					ZoneMap.highlight();
					ZoneMap.calcData();
				});

			},
			function (err) {
				console.log(err);
			}
		);
	},

	runAfterYmlLoaded: function (callback) {
		var tm = setInterval(function () {
			if (ZoneMap.ymlLoaded) {
				callback();
				clearInterval(tm);
			}
		}, 100);
	},

	calcData: function () {
		let ids = ZoneMap.getSelectedSatelliteButtons().map(function (item) {
			return item.data.get('id')
		});

		ids.forEach(function (id) {
			var config = ZoneMap.getSatelliteConfig(id);

			let coords = ZoneMap.getPlacemarkCoordinates();

			config.angle = ZoneMap.calcDataAngle(config.standing_coords, coords[0], coords[1]);
			config.azimuth = ZoneMap.calcDataAzimuth(config.standing_coords, coords[0], coords[1]);
			config.distance = output_numbers(ZoneMap.calcDataDistance(config.standing_coords, coords[0], coords[1]));

			ZoneMap.printCalcData(id, config);
		});
	},
	calcDataAngle: function (e, t, a) {
		for (var i = Math.PI / 180, o = 180 / Math.PI, n = e - a; n < -180;) n += 360;
		for (; n > 180;) n -= 360;
		return (n = Math.atan((Math.cos(Math.acos(Math.cos(n * i) * Math.cos(t * i))) - .1513) / Math.sin(Math.acos(Math.cos(n * i) * Math.cos(t * i)))) * o).toFixed(2)
	},
	calcDataAzimuth: function (e, t, a) {
		var i = Math.PI / 180,
			o = (Math.PI + Math.atan(Math.tan(a * i - e * i) / Math.sin(t * i))) / i;
		return o.toFixed(2);
	},
	calcDataDistance: function (e, t, a) {
		return parseInt(6378.16 * Math.sqrt(Math.pow(42164 / 6378, 2) + 1 - 42164 / 6378 * 2 * Math.cos((a - e) * (Math.PI / 180)) * Math.cos(t * (Math.PI / 180))));
	},
	printCalcData: function (id, data) {
		let $container = $(".vg-area-coverage .sputnik[data-id='" + id + "']");

		$container.find('.sputnik-content .item[data-param]').each(function (i, e) {
			var paramName = $(e).data('param');
			var paramValue = data[paramName];

			$(e).find('.v').text(paramValue);
		});
	},
};

$(document).ready(function () {
	if (ZoneMap.zoneMap().length) {
		ymaps.ready(ZoneMap.initMap);

		$(window).resize(function () {
			let $map = ZoneMap.zoneMap();
			let w = $(window).width();
			let ch = $map.data('height-current');
			let nh = w > 600 ? 'desktop' : 'mobile';

			if (ch !== nh) {
				$map.data('height-current', nh);
				let newHeight = $map.data('height-' + nh);
				$map.height(newHeight);

				ZoneMap.myMap.container.fitToViewport();
			}
		});

		$(document).on('click', '.vg-area-coverage a[data-close=address]', function () {
			ZoneMap.setCoords(false);
			ZoneMap.setAddress('');
			return false;
		});
	}
});
